let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7Rr8O")).then(() => parcelRequire('kL67x'));